import { Pipe, PipeTransform } from '@angular/core';
import { SoftwarePermissionCode } from 'src/app/core/models/permissions/permission-code';
import { User } from 'src/app/core/models/user/user.model';

@Pipe({
  name: 'userHavePermissionForAnyAlarms'
})
export class UserHavePermissionForAnyAlarmsPipe implements PipeTransform {

swPermissions = SoftwarePermissionCode;
  transform(user: User): boolean {
    return user.havePermission(SoftwarePermissionCode.AlarmsSosReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsRoomBurglaryReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsRoomSafeBurglaryReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsTemperatureDifferenceReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsWaterFloodReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsPowerOutageReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsDCOutputsFailureReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsControllerTemperatureReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsWindowOpenTooLongReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsDoorOpenTooLongReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsRoomSafeCommErrorReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsCommunicationErrorReceive);
   /*  return user.havePermission(SoftwarePermissionCode.AlarmsBurglaryReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsHvacReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsOpenTooLongReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsSafetyReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsSosReceive) ||
    user.havePermission(SoftwarePermissionCode.AlarmsSystemReceive); */
  }

}
